<template>
	<article class="page-container bg-white" v-if="page">
		<header class="page-header">
			<h1 class="page-title" v-if="page.title">{{ page.title }}</h1>

			<div class="page-thumbnail" v-if="page.image_url">
				<img :src="$options.filters.imageproxy(page.image_url, 1160)" alt="Page Thumbnail">
			</div>
		</header>

		<section class="page-content" v-html="page.content" />
	
		<section class="page-additional-content" v-html="page.additional_content" />

		<section class="page-infos">
			<accordion :items="page.infos" />
		</section>
	</article>
</template>

<script>
	import checkforupdates from '@/mixins/checkforupdates.js'
	import Accordion from '@/components/foundation/Accordion.vue'

	export default{
		name: 'SingleCardInfoPage',
		mixins: [ checkforupdates ],
		components: {
			Accordion
		},
		metaInfo() {
			return {
				title: 'Kärnten Card App',
				meta: [{
					property: 'og:title', content: 'Kärnten Card App'
				}, {
					property: 'og:site_name', content: 'Kärnten Card App'
				}, {
					property: 'og:url', content: window.location.href
				}, {
					property: 'og:image', content: this.page === null ? '' : (this.$options.filters.imageproxy(this.page.image_url, 600) || '')
				},{
					property: 'og:description', content: this.page === null ? '' : (this.page.content || '')
				}]
			}
		},

		computed: {
			requestedPageName (){
				return this.$route.name
			},
			page() {
				if (this.requestedPageName === 'home') {
					return this.$store.getters.getCardInfoPageByName(this.requestedPageName)
				}
				if (this.requestedPageName === 'single-card-info' && this.$route.params.uuid) {
					return this.$store.getters.getCardInfoByID(this.$route.params.uuid)
				}

				return null
			}
		},
		watch: {
			'$store.state.language': function (newLang) {
				this.$store.dispatch('fetchCardInfos', { lang: newLang, season: this.$store.state.season })
					.then(() => {
						this.$store.dispatch('fetchNews', { lang: newLang, season: this.$store.state.season })
					})
			},
			'$store.state.season': function (newSeason) {
				this.$store.dispatch('fetchCardInfos', { lang: this.$store.state.language, season: newSeason })
					.then(() => {
						this.$store.dispatch('fetchNews', { lang: this.$store.state.language, season: newSeason })
					})
			}
		}
	}
</script>

<style lang="scss" scoped>
	.page-container{
		margin-top: .25rem;
	}
	.page-title{
		color: get-color(primary);
	}
</style>

<style lang="scss">
	.page-thumbnail{
			margin-bottom: .5rem!important;
	}
	.notification-shell{
		text-align: center;
		color: $white;

		.notification-content{
			line-height: 1.2;
			margin-top: .5rem;
			margin-bottom: 1rem;
		}



		.btn-update{
			@include button(
				false,
				get-color(secondary),
				scale-color(get-color(secondary), $lightness: 20%),
				$dark-gray,
				'solid'
			);
			margin-bottom: .5rem;
		}
	}
</style>
